import { createContext } from "react";
import type { Notification, RollResult, TagAction, RestNotification } from "~/types/character";

/**
 * Notification Context Value
 *
 * Provides notification and roll history state and update functions to components.
 */
export interface NotificationContextValue {
  notifications: Notification[];
  rollHistory: RollResult[];

  // Add notifications
  addRollNotification: (roll: RollResult) => void;
  addTagNotification: (action: TagAction) => void;
  addRestNotification: (rest: RestNotification) => void;

  // Dismiss/clear
  dismissNotification: (id: string) => void;
  clearRoll: (id: string) => void;
  clearAllRolls: () => void;
}

/**
 * Context for notification management
 *
 * Should only be accessed via useNotifications() hook, not directly.
 * Will be undefined if used outside of NotificationProvider.
 */
export const NotificationContext = createContext<NotificationContextValue | undefined>(undefined);
